import Button from '@mui/material/Button';
import { useNotify } from '@shared/notifications';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// `virtual:pwa-register/react` is provided by vite-plugin-pwa at build time.
// In dev with `devOptions.enabled = false` it returns a no-op stub.
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Subscribes to the workbox-window registration so we can surface a
 * "Reload to update" prompt the moment a new build's service worker has
 * finished installing in the background. Handle should be mounted exactly
 * once, near the root.
 */
export function ServiceWorkerUpdate() {
  const { t } = useTranslation();
  const notify = useNotify();
  const { needRefresh, updateServiceWorker } = useRegisterSW({
    onOfflineReady() {
      notify.info(t('pwa.offlineReady'));
    },
    onRegisterError(err: unknown) {
      console.warn('[pwa] sw register failed', err);
    },
  });

  const [pending] = needRefresh;

  useEffect(() => {
    if (!pending) return;
    notify.info(t('pwa.updateAvailable'), {
      persist: true,
      action: (
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            void updateServiceWorker(true);
          }}
        >
          {t('pwa.reload')}
        </Button>
      ),
    });
  }, [pending, notify, t, updateServiceWorker]);

  return null;
}
